<template>
  <div class="c-text-label" :style="labelElementStyle">
    <span class="c-text-label__text">
      <slot>ラベル</slot>
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props:{
    color: 	{
      type: [Boolean, Object],
        default: () => ({
          border: "#616161",
          content: "#ffffff"
        })
    },
    reverse: { type: Boolean, default: false },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  }
})
export default class TextLabel extends Vue {

  color!: boolean | any;
  reverse!: boolean;
  customStyle!: any;
  labelElementStyle = {};

  async created() {
    const reverse = this.reverse;
    const color = this.color;
    const customStyle = this.customStyle;

    const borderColor = color.border;
    const contentColor = color.content;

    const backgroundColor = this.initStyle(contentColor, borderColor);
    const textColor = this.initStyle(borderColor, contentColor);

    const labelElementStyle = {
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      color: textColor
    };

    this.labelElementStyle = Object.assign(customStyle, labelElementStyle);
  }

  initStyle(defaultStyle: any, reverseStyle: any) {
    const reverse = this.reverse;
    return reverse ? reverseStyle : defaultStyle;
  }
}
</script>

<style lang="scss" scoped>
.c-text-label {
  @include pc {
    min-width: rem(88);
  }
  @include sp {
    min-width: rem(78);
  }
  font-size: rem(10);
  display: inline-block;
  text-align: center;
  border-style: solid;
  border-width: px(1);
  padding: 0 rem(2);
  border-radius: rem(20);
  font-weight: bold;

  &__text {
    line-height: 1.6;
    display: inline-block;
  }
}
</style>
